module.exports = __webpack_public_path__ + "media/images/noaa-logo-65x65-7c8161889e0bac30018c08e7d9a970cf.png";